import { OrderBy } from 'mk2/apps/forum/containers/ForumFeed/ForumFeed.reducers';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';
import { Action } from 'redux';

///////////////////////////////////////////////////////////////////
// Progress broadcast

export interface ForumFeedFetchAction extends Action {
    readonly orderBy: OrderBy;
    readonly after: number; // Last item id
}
export const FORUM_FEED_FETCH_REQUEST = 'FORUM_FEED_FETCH_REQUEST';
export interface ForumFeedFetchRequestAction extends ForumFeedFetchAction, APIRequestAction {
    readonly type: typeof FORUM_FEED_FETCH_REQUEST;
}
export interface ForumFeedFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        posts: number[];
        myAnonymousPosts: number[];
        activeBrandDays: { posts: number[]; campaign: number; };
    };
}
export const FORUM_FEED_FETCH_SUCCESS = 'FORUM_FEED_FETCH_SUCCESS';
export interface ForumFeedFetchSuccessAction extends ForumFeedFetchAction, APISuccessAction<ForumFeedFetchNormalizedResponse> {
    readonly type: typeof FORUM_FEED_FETCH_SUCCESS;
    readonly hasNext: number;
    readonly hasPrevious: number;
    readonly notificationsOn: number[];
    readonly topicsCount: number;
}

export const FORUM_FEED_FETCH_FAILURE = 'FORUM_FEED_FETCH_FAILURE';
export interface ForumFeedFetchFailureAction extends ForumFeedFetchAction, APIFailureAction {
    readonly type: typeof FORUM_FEED_FETCH_FAILURE;
}

export const forumFeedFetch = {
    request: (orderBy: OrderBy, after: number): ForumFeedFetchRequestAction => ({
        type: FORUM_FEED_FETCH_REQUEST, orderBy, after,
    }),
    success: (orderBy: OrderBy, after: number, hasNext: number, hasPrevious: number, notificationsOn: number[], topicsCount: number, response: ForumFeedFetchNormalizedResponse):
        ForumFeedFetchSuccessAction => ({
        type: FORUM_FEED_FETCH_SUCCESS, orderBy, after, hasNext, hasPrevious, notificationsOn, topicsCount, response,
    }),
    failure: (orderBy: OrderBy, after: number, error: any): ForumFeedFetchFailureAction => ({
        type: FORUM_FEED_FETCH_FAILURE, orderBy, after, error,
    }),
};

// Forum feed load
export const FORUM_FEED_LOAD = 'FORUM_FEED_LOAD';
export interface ForumFeedLoadAction extends ForumFeedFetchAction {
    readonly type: typeof FORUM_FEED_LOAD;
}
export const forumFeedLoad = (orderBy: OrderBy, after?: number): ForumFeedLoadAction => ({
    type: FORUM_FEED_LOAD, orderBy, after,
});
